'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recent = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Recent, _Component);

  function Recent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Recent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Recent.__proto__ || (0, _getPrototypeOf2.default)(Recent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.renderLatestActivity = function () {
      var obj = _this.calcProgressOfModule();
      var styles = require('./Profile.scss');
      var mod = '';
      switch (obj.recent) {
        case 'module0':
          mod = 'Getting Ready';break;
        case 'module1':
          mod = 'Healthy eating eabits';break;
        case 'module2':
          mod = 'Home food environment';break;
        case 'module3':
          mod = 'Encouraging vegetables';break;
        case 'module4':
          mod = 'Review and future planning';break;
        case 'module5':
          mod = 'Continuing progress after Reboot Kids';break;
        default:
          break;
      }

      return _react2.default.createElement(
        'div',
        null,
        console.log("the progress is " + obj.progress + " the recent is " + obj.recent),
        obj.recent === 'module0' && obj.progress === 0 && _react2.default.createElement(
          'div',
          { className: styles.textCenter },
          _react2.default.createElement(
            'h3',
            null,
            'Get started with Reboot Kids!'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Begin with  ',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/moduleslanding' },
              'modules'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 })
        ),
        (obj.recent !== 'module0' || obj.progress !== 0) && obj.recent !== 'module5' && !(obj.recent === 'module4' && obj.progress >= 100) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            'You were up to:',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/' + obj.recent },
              _react2.default.createElement(
                'strong',
                null,
                ' ',
                mod
              ),
              console.log("the recent obj is" + obj.recent)
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(ReactBootstrap.ProgressBar, { bsStyle: 'success', now: obj.progress })
        ),
        (obj.recent === 'module5' || obj.recent === 'module4' && obj.progress >= 100) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            'You\'ve finished Reboot Kids!',
            _react2.default.createElement(
              'strong',
              null,
              ' Well Done!'
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(ReactBootstrap.ProgressBar, { bsStyle: 'success', now: 100 })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Recent, [{
    key: 'calcProgressOfModule',
    value: function calcProgressOfModule() {
      var key = '';
      var mostRecent = '';
      for (key in this.props.app) {
        if (this.props.app.hasOwnProperty(key)) {
          if (this.props.app[key].numAppCompleted < this.props.app[key].numAppTotal) {
            mostRecent = key;
            break;
          }
        }
      }

      return { 'recent': mostRecent,
        'progress': this.props.app[mostRecent].numAppCompleted / this.props.app[mostRecent].numAppTotal * 100 };
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.card + ' ' + styles.cardContent },
          _react2.default.createElement(
            'h2',
            { className: styles.orangeText + ' ' + styles.textCenter },
            'Recent activity'
          ),
          this.renderLatestActivity()
        )
      );
    }
  }]);
  return Recent;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Recent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Recent.js
// module id = 1227
// module chunks = 0